.container--disabled {
  cursor: not-allowed;
}

.container--readonly {
  cursor: default;
}

.inner-single-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
  max-width: 100%;
}

.control {
  &:hover:not(.control--readonly) .dropdown-indicator,
  &:focus-within .dropdown-indicator {
    color: var(--dds-color-icon-action-hover);
  }
}

.control--readonly .dropdown-indicator {
  pointer-events: none;
}

.control--disabled .dropdown-indicator {
  pointer-events: none;
}
